/**
 * The landing footer: the brand and its one-line promise, the page's own
 * destinations, where Mouja is, and the language switch. Every link goes
 * somewhere that exists on this page or in the product; nothing is listed
 * because footers usually list it.
 */
import { Languages } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/language.js';
import { LandingWordmark } from './LandingWordmark.js';

export function LandingFooter(): React.ReactElement {
  const { copy, language, toggle } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="mj-landing-footer" aria-label={copy.footer.landmark}>
      <div className="mj-landing-footer-inner">
        <div className="mj-landing-footer-brand">
          <LandingWordmark height={30} />
          <p>{copy.footer.tagline}</p>
          <span className="mj-landing-footer-location">{copy.footer.location}</span>
        </div>

        <div
          className="mj-landing-footer-nav"
          role="group"
          aria-label={copy.footer.product}
        >
          <span className="mj-landing-footer-heading">{copy.footer.product}</span>
          <a href="#how-it-works">{copy.footer.howItWorks}</a>
          <a href="#product-story">{copy.footer.story}</a>
          <a href="#waitlist">{copy.footer.waitlist}</a>
        </div>

        <div
          className="mj-landing-footer-nav"
          role="group"
          aria-label={copy.footer.account}
        >
          <span className="mj-landing-footer-heading">{copy.footer.account}</span>
          <Link to="/signin">{copy.nav.signIn}</Link>
          <button type="button" onClick={toggle} lang={language === 'en' ? 'ar' : 'en'}>
            <Languages size={16} strokeWidth={1.5} aria-hidden="true" />
            {copy.nav.otherLanguageName}
          </button>
        </div>
      </div>

      <div className="mj-landing-footer-legal">
        <span>{copy.footer.rights(year)}</span>
        <span className="mj-landing-footer-made">{copy.footer.made}</span>
      </div>
    </footer>
  );
}
